$(() => {
  $('.js-static-submitter').on('blur', '.js-submit-trigger', e => {
    $(e.currentTarget).closest('form').submit();
  });

  $('.js-static-submitter').on('ajax:success', 'form[method=post]', e => {
    const $form = $(e.currentTarget);

    $form.find('.js-message-container').addClass('has-success');
    $form.find('.js-feedback-icon').show('fast');
    setTimeout(() => {
      $form.find('.js-feedback-icon').hide('fast');
      $form.find('.js-message-container').removeClass('has-success');
    }, 1500);
  });
});
